import { Injectable } from '@angular/core';

import { AppUrl } from './../../Common/appUrl';
import { IesHttpClient } from '../../Common/ies-http-client.service';
import { AppGlobals } from './../../Common/Services/app.global';
import { Observable } from 'rxjs';
import { Utility } from "./../../Common/Services/utility";

export type Profile = {
  id: number;
  name: {
    first: string;
    last: string;
  };
  certificate: {
    id: number | null;
  };
  phone: string | undefined;
}

export type PatchProfile = {
  phone?: string;
  certificate?: {
    id: string;
  };
};

@Injectable()
export class ScheduleExamDateService {

  constructor(private _httpClient: IesHttpClient, private appGlobal: AppGlobals, private _utility: Utility) {
  }

  // call API to get Exam time slots
  getExamSlots(examType: "XE" | "RE" | "CE" | "PE", urlParams) {
    switch (examType) {
      case "XE":
        return this._httpClient.get("../../ies/api/schedule/timeslots/experience", urlParams);
      case "RE":
        return this._httpClient.get("../../ies/api/schedule/timeslots/remote", urlParams);
      case "CE":
        return this._httpClient.get("../../ies/api/schedule/timeslots/testing-center", urlParams);
      case "PE":
        return this._httpClient.get("../../ies/api/schedule/timeslots/preliminary", urlParams);
      default:
        throw new Error("This method has not been implemented for the input provided")
    }
  }

  getProfile(): Observable<Profile> {
    return this._httpClient.get("../../ies/api/profile")
  }

  updateProfile(body: PatchProfile): Observable<Profile> {
    return this._httpClient.patch("../../ies/api/profile", body)
  }

  // call API to schedule/reschedule exam
  scheduleExam(examType: "XE" | "RE" | "CE" | "PE", body: any) {
    let url;
    switch (examType) {
      case "XE":
        url = "../../ies/api/schedule/experience/" + body.eligibility.code;
        break;
      case "RE":
        url = "../../ies/api/schedule/remote/" + body.eligibility.code;
        break;
      case "CE":
        url = "../../ies/api/schedule/testing-center/" + body.eligibility.code;
        break;
      case "PE":
        url = "../../ies/api/schedule/preliminary/" + body.eligibility.code;
        break;
      default:
        throw new Error("This method has not been implemented for the input provided")
    }
    return this._httpClient.post(url, body);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/schedule-exam-date/schedule-exam-date.service.ts